import i18n from './i18n'

const validation = {

  install (Vue) {
    Vue.prototype.$validate = {
      username: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /[ ._a-zA-z0-9@-]/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      password: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => (v && v.length > 3) || i18n.t('general.passwordLength')
      ],
      email: [
        v => !!v || i18n.t('backbone.validation.required'),
        /* eslint-disable no-useless-escape */
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || i18n.t('backbone.validation.email')
      ],
      notemptyRules: [
        v => !!v || i18n.t('backbone.validation.required')
      ],
      authenticator: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[ 0-9]{6,7}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      seedRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[0-9abcdef]{8}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      isNumber: [
        v => (typeof v === 'number') || i18n.t('backbone.validation.required')
      ],
      nameRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[a-zA-Z0-9äÄöÖüÜßÂâêîôûàèáéçœæ¡¿áéíóúÁÉÍÓÚñÑòàéèùìÃ¤ªº³å©®™@&_()#[\] \-,.+:'/]{1,255}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      nameRules64: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[a-zA-Z0-9äÄöÖüÜßÂâêîôûàèáéçœæ¡¿áéíóúÁÉÍÓÚñÑòàéèùìÃ¤ªº³å©®™@&_()#[\] \-,.+:'/]{1,64}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      encryptedId: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[0-9abcdef]{32}(-[0-9abcdef]{6,28})?$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      unitRules: [
        v => !!((v && v.toLowerCase()) || '').match(/^[+#a-z0-9₂ ²³°€$¥£łgΩ$/%&μöäüßâêîôûàèáéçœæ¡¿()\[\]áéíóúÁÉÍÓÚñÑòàéèùì-]{0,32}$/i) || i18n.t('general.errorInvalidCharacters') + '!'
      ],
      couponRules: [
        v => !!(v || '').match(/^[+#0-9a-z-]{8,10}$/i) || i18n.t('coupon.invalidToken') + '!'
      ],
      valueRules: [
        v => (!isNaN(parseFloat(v)) && !isNaN(v - 0)) || i18n.t('backbone.validation.number')
      ],
      viatagRules: [
        v => !!(v || '').match(/^([A-Za-z0-9][A-Za-z0-9-]{2,60}[A-Za-z0-9])$/i) || i18n.t('general.errorInvalidCharacters') + '!'
      ],
      supportTokenRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => !!(v || '').match(/^[0-9]{6}$/i) || 'Ungültiger Support-Token!'
      ],
      modulenameRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[a-zA-Z0-9äÄöÖüÜßÂâêîôûàèáéçœæ¡¿áéíóúÁÉÍÓÚñÑòàéèùìÃ¤ªº³å©®™@&_()#[\];=<> \-,.+:'/]{1,128}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      required: [
        v => !!v || i18n.t('backbone.validation.required')
      ],
      twoFactorAuthenticationRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^[0-9]{3} ?[0-9]{3}|[0-9abcdef]{5}-[0-9abcdef]{5}$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      decimalNumberRules: [
        v => !!v || i18n.t('backbone.validation.required'),
        v => /^(\d+\.?\d{0,9}|\.\d{1,9})$/.test(v) || i18n.t('general.errorInvalidCharacters')
      ],
      serial: [
        v => /^[0-9A-Fa-f]{12}$/.test(v) || 'Invalid serial!'
      ]
    }
  }
}

export default validation



// WEBPACK FOOTER //
// ./src/plugins/validation.js